var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<a class=\"mdc-button mdc-js-button\" ng-class=\"$ctrl._classes\" ng-style=\"$ctrl._customStyles\" ng-href=\"{{ $ctrl.link }}\" target=\"{{:: $ctrl.target }}\">\n<i class=\"icon\" ng-class=\"::$ctrl.icon\" ng-if=\"::$ctrl.icon\"></i>\n<span class=\"mdc-button-main-content\" ng-transclude></span>\n</a>\n";
var id1="common/material-components/buttons/link.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/common/material-components/buttons/link.tpl.html
// module id = 189
// module chunks = 6